var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-add-insumo"},[_c('b-button',{class:("" + (this.escritoBotao ? 'button-adicionar' : 'button-animation')),on:{"click":_vm.buttonAnimation}},[(_vm.escritoBotao)?_c('div',[_vm._v("Adicionar")]):_vm._e(),_vm._v(" "),(!_vm.escritoBotao)?_c('div',[_c('i',{staticClass:"fas fa-check icone-check"})]):_vm._e()])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43db34ce","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/realestate/ocurrence/components/InputCosts/components/inputbutton.vue
// module id = null
// module chunks = 